import { all } from "redux-saga/effects";
import { addProductToCartSaga } from "./addProductToCart/sagas";
import { addressSuggestionsSaga } from "./addressSuggestions/addressSuggestionsSagas";
import { adviceSaga } from "./advice/sagas";
import { advicePDFSaga } from "./advicePDF/sagas";
import { akaAdviceSaga } from "./akaAdvice/sagas";
import { akaHealthConfigSaga } from "./akaHealthConfig/akaHealthConfigSaga";
import { analyticsSaga } from "./analytics/analyticsSaga";
import { cartSaga } from "./cart/cartSagas";
import { companiesSaga } from "./companies/sagas";
import { consentSaga } from "./consent";
import { downtimeSaga } from "./downtime/sagas";
import { estateSaga } from "./estate/estateSagas";
import { errorDisplayedSaga } from "./eventFailed/errorDisplayedSaga";
import { operationFailedSaga } from "./eventFailed/operationFailedSaga";
import { findAnimalBreedSaga } from "./findAnimalBreed/findAnimalBreedSaga";
import { findVehicleSaga } from "./findVehicle/sagas";
import { findVehicleTypeSaga } from "./findVehicleType/sagas";
import { getVeteranVehicleModelSaga } from "./getVeteranVehicleModel/sagas";
import { localStorageSaga } from "./localStorage/localStorageSaga";
import { offerAcceptSaga } from "./offerAccept/offerAcceptSagas";
import { offerSaga } from "./offerEmail/sagas";
import { partnerSaga } from "./partners/partnerSagas";
import { postNumberSaga } from "./postNumber/postNumberSagas";
import { priceCalculationSaga } from "./priceCalculation/priceCalculationSagas";
import { productSaga } from "./product/productSagas";
import { textSaga } from "./texts/sagas";
import { updateHuseierneMembershipStatusSaga } from "./updateHuseierneMembershipStatus/sagas";
import { userIdentificationSaga } from "./userIdentification";
import { validateCustomerNameSaga } from "./validateCustomerName/sagas";
import { validateLicensePlateSaga } from "./validateLicensePlate/sagas";
import { validateProductNameNinSaga } from "./validateProductNameNin/sagas";

function* rootSaga(): Generator {
  yield all([
    addProductToCartSaga(),
    addressSuggestionsSaga(),
    advicePDFSaga(),
    adviceSaga(),
    akaAdviceSaga(),
    akaHealthConfigSaga(),
    analyticsSaga(),
    cartSaga(),
    companiesSaga(),
    consentSaga(),
    downtimeSaga(),
    errorDisplayedSaga(),
    estateSaga(),
    findAnimalBreedSaga(),
    findVehicleSaga(),
    findVehicleTypeSaga(),
    getVeteranVehicleModelSaga(),
    localStorageSaga(),
    offerAcceptSaga(),
    offerSaga(),
    operationFailedSaga(),
    partnerSaga(),
    postNumberSaga(),
    priceCalculationSaga(),
    productSaga(),
    textSaga(),
    updateHuseierneMembershipStatusSaga(),
    userIdentificationSaga(),
    validateCustomerNameSaga(),
    validateLicensePlateSaga(),
    validateProductNameNinSaga(),
  ]);
}

export default rootSaga;
